import type {
  FixedIdentitySessionRequest,
  SessionResult,
} from './generated/types';
import { randomUuid } from './randomUuid';
import type { ActiveTransport } from './transport';

export function createFixedIdentitySession(
  transport: ActiveTransport,
  body: FixedIdentitySessionRequest,
) {
  return transport.request<SessionResult>('/auth/fixed-session', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Idempotency-Key': randomUuid(),
    },
    body: JSON.stringify(body),
  });
}
